import fetchMock from 'jest-fetch-mock';

// Docs: https://github.com/jefflau/jest-fetch-mock#default-not-mocked
//If you would like to have the 'fetchMock' available in all tests but not enabled then add fetchMock.dontMock()
//after the ...enableMocks() line in setupJest.js:

// adds the 'fetchMock' global variable and rewires 'fetch' global to call 'fetchMock' instead of the real implementation
fetchMock.enableMocks();
// changes default behavior of fetchMock to use the real 'fetch' implementation and not mock responses
fetchMock.dontMock();
